import { settings } from '../../../settings/settings-util';
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';
import { InitializationStep } from '../../../types/initialization';
import { EntryOriginTypesV5 } from '@alme/api-ts/Alme/EntryOriginTypes';
import ResponseHandler from '../../../types/response-handler';
import { AlmeUIMessage } from '../../../types/response';
import { ConfigurationResponse } from '@alme/types/response/ConfigurationResponse';
import objectPath from 'object-path';

export default class InitializeGetConfiguration extends ResponseHandler implements InitializationStep {

    constructor(passedSettings?: typeof settings) {
        super(["GetConfigurationRequest"], passedSettings);
    }

    getPromise(): Promise<void> {
        const input = {
            messageType: this._settings.messageConstants.getConfigurationRequest,
            origin: this._settings.originConstants.internal as EntryOriginTypesV5,
        };
        return sendRequest(input) as unknown as Promise<void>;
    }

    process(message: AlmeUIMessage): AlmeUIMessage {
        if (!this.doesHandle(message)) { return message; }
        const response = message.response as ConfigurationResponse;
        const Alme = this._settings.Alme ?? {};
        for (const ConfigPair of response.configurationSettings) {
            if (!ConfigPair.Key.includes('.')){
                Alme[ConfigPair.Key] = ConfigPair.Value;
            }
            else {
                const parsedSettingKey = ConfigPair.Key.split('.');
                if (!Alme[parsedSettingKey[0]]) {
                    Alme[parsedSettingKey[0]] = {};
                }
                Alme[parsedSettingKey[0]][parsedSettingKey[1]] = ConfigPair.Value;
            }
        }
        objectPath.set(this._settings, "Alme", Alme);
        return message;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/initialization-get-configuration/src/initialization-get-configuration.ts